module.exports = __webpack_public_path__ + "img/ticket-now-gray.bc7b700a.svg";